import React, { useCallback } from "react";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import config from "../../config";
import { useNavigate } from "react-router";
import useLogout from "../Auth/useLogout";
import Loader from "../../Component/Loader";

export default function BecomeSupplier() {
  const navigate = useNavigate();
  const logout = useLogout();
  const user = config.user;
  const [sellerType, setSellerType] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    axios
      .get(`${config.apiUrl}/registration-form-info`)
      .then((res) => {
        setSellerType(res.data.seller_type);
      })
      .catch((error) => {});
  }, []);
  const [responseError, setResponseError] = useState({
    nameError: "",
    companyNameError: "",
    gstError: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    company_name: "",
    gst_number: "",
    pan_number: "",
    company_address: "",
    phone: "",
    email: "",
    supplier: "",
  });
  const fetchUserProfile = useCallback(async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/customer/profile`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      });
      setFormData((prevData) => ({
        ...prevData,
        name: response.data.data.name ?? "",
        company_name: response.data.data.user_detail?.company_name ?? "",
        gst_number: response.data.data.user_detail?.gst_number ?? "",
        pan_number: response.data.data.user_detail?.pan_number ?? "",
        company_address: response.data.data.user_detail?.company_address ?? "",
        phone: response.data.data.phone ?? "",
        email: response.data.data.email ?? "",
      }));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  }, [logout]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateData = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.nameError = "Name is required";
    }
    if (!formData.company_name) {
      newErrors.companyNameError = "Company name is required";
    }
    if (!formData.gst_number) {
      newErrors.gstError = "GST number is required";
    }

    setResponseError(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateData()) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${config.apiUrl}/customer/become-seller`,
          {
            user_name: formData.name,
            email: formData.email,
            company_name: formData.company_name,
            seller_type: formData.supplier ? [+formData.supplier] : [],
            pan_number: formData.pan_number,
            gst_number: formData.gst_number,
            address: formData.company_address,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );

        var localData = {
          name: user.name,
          type: "seller",
          email: user.email,
          phone: user.phone,
        };
        Cookies.set("bz_uinf", JSON.stringify(localData), { expires: 7 });
        config.user =
          Cookies.get("bz_uinf") && JSON.parse(Cookies.get("bz_uinf"));
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        resetData();
        setTimeout(() => {
          navigate("/commodity-products");
        }, 1500);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        setLoading(false);
      }
    }
  };
  const resetData = () => {
    setFormData({
      name: "",
      company_name: "",
      gst_number: "",
      pan_number: "",
      company_address: "",
      phone: "",
      email: "",
      supplier: "",
    });
  };

  return (
    <>
      <div className="sup-hero">
        <div className="container-fluid">
          <div className="row gap-row">
            <div className="col-lg-6 mt-4">
              <div className="sup-hero-intro">
                <h4>
                  Become a <span className="text-danger">Seller</span>
                </h4>
                <h1>
                  {" "}
                  We are empowering suppliers, elevating success-more sales,
                  less worries!!
                </h1>
                <p>
                  Unlock prosperity with Biznie: Seemless transactions,
                  nationwide market and payment security.
                </p>
              </div>
            </div>
            <div className="col-lg-6 my-auto p-5 bg-white rounded">
              <h6 className="text-secondary">
                Biznie - Your path to growth: Amplify your sales, expand your
                reach.
              </h6>

              <form className="sup-frm" onSubmit={handleSubmit}>
                <div className="row gx-4">
                  <div className="col-lg-6">
                    <label className="form-label" htmlFor="name">
                      Name*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Buyer name"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {responseError.nameError && (
                      <small className="input-error">
                        {responseError.nameError}
                      </small>
                    )}
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label" htmlFor="company_name">
                      Company Name*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Company name"
                      id="company_name"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleChange}
                    />
                    {responseError.companyNameError && (
                      <small className="input-error">
                        {responseError.companyNameError}
                      </small>
                    )}
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label" htmlFor="email">
                      Email*
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label" htmlFor="supplier">
                      Supplier Type*
                    </label>
                    <select
                      className="form-control"
                      id="supplier"
                      name="supplier"
                      value={formData.supplier}
                      onChange={handleChange}
                    >
                      <option value="" disabled>Select Supplier Type</option>
                      {sellerType.map((sType) => {
                        return (
                          <option value={sType.id} key={sType.id}>
                            {sType.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label" htmlFor="pan_number">
                      Pan Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pan number"
                      id="pan_number"
                      name="pan_number"
                      value={formData.pan_number}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label" htmlFor="gst_number">
                      Gst Number*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Gst number"
                      id="gst_number"
                      name="gst_number"
                      value={formData.gst_number}
                      onChange={handleChange}
                    />
                    {responseError.gstError && (
                      <small className="input-error">
                        {responseError.gstError}
                      </small>
                    )}
                  </div>
                  <div className="col-lg-12">
                    <label className="form-label" htmlFor="company_address">
                      Company Address*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Company address"
                      id="company_address"
                      name="company_address"
                      value={formData.company_address}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-12">
                    <button
                      type="submit"
                      className="btn btn-success w-100 rounded"
                      disabled={loading}
                    >
                      {loading ? <Loader /> : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
